import { restApi } from '../../../services/Api'

const veiculosRepository = {
  veiculoKmm: placa => {
    return restApi.get(`veiculosKmm/${placa}`)
  },
  conjuntoKmm: placa => {
    return restApi.get(`veiculosKmm/conjunto/${placa}`)
  }
}

export default veiculosRepository
